export type Category = {
  slug: string;
  name: string;
  desc: string;
  icon: string;
  count: number;
  tone: 'primary' | 'accent' | 'secondary';
};

export const categories: Category[] = [
  {
    slug: 'event-track',
    name: '事件追踪',
    desc: '按时间线还原一场瓜的起因、经过与最新进展，避免只看到被剪辑过的片段。',
    icon: 'ri-route-line',
    count: 128,
    tone: 'primary',
  },
  {
    slug: 'person-profile',
    name: '人物档案',
    desc: '梳理事件中出现的男方、女方与当事人口径，区分「已确认」与「网传」信息。',
    icon: 'ri-user-search-line',
    count: 96,
    tone: 'accent',
  },
  {
    slug: 'alt-account',
    name: '小号鉴定',
    desc: '从发言习惯、发布时间、设备特征等角度判断所谓「小号」是否真的有关联。',
    icon: 'ri-user-shared-line',
    count: 74,
    tone: 'secondary',
  },
  {
    slug: 'fact-check',
    name: '真伪鉴定',
    desc: '对流传的截图、聊天记录与爆料声明逐条核对，标注可信度等级。',
    icon: 'ri-shield-check-line',
    count: 63,
    tone: 'primary',
  },
  {
    slug: 'trend-watch',
    name: '舆情风向',
    desc: '观察话题的热度曲线与评论区主要观点，看清舆论是在放大还是在回落。',
    icon: 'ri-line-chart-line',
    count: 41,
    tone: 'secondary',
  },
  {
    slug: 'glossary',
    name: '吃瓜词典',
    desc: '解释「空降」「实锤」「白月光」等圈内黑话，让新吃瓜的人也能跟上节奏。',
    icon: 'ri-book-2-line',
    count: 35,
    tone: 'accent',
  },
];

export const getCategoryBySlug = (slug: string): Category | undefined =>
  categories.find((item) => item.slug === slug);